<template>
  <div>
    <div v-show="listing" class="app-content content ">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper">
        <div class="content-header row">
          <div class="content-header-left col-md-9 col-12 mb-2">
            <Breadcrumb
                name="Customer"
                bc1="App"
                bc2="Customer"
                bc3="List"
            ></Breadcrumb>
          </div>
        </div>
        <div class="content-body">
          <div class="card">
            <h5 class="card-header">Search Filter</h5>
            <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
              <div class="col-lg-4 col-sm-12 ">
                <date-picker
                  v-model="fromDate"
                  :disabledDate="disableFutureDates"
                  valueType="format"
                  :lang="lang"
                  name="fromDate"
                  placeholder="choose start date"
                ></date-picker>
              </div>
              <div class="col-lg-4 col-sm-12">
                <date-picker
                  v-model="toDate"
                  :disabledDate="disableFutureDates"
                  valueType="format"
                  :lang="lang"
                  name="toDate"
                  placeholder="choose end date"
                ></date-picker>
              </div>
            </div>
            <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
              <div class="col-md-6 user_plan mb-1">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <div class="">
                      <label>Select Store</label>
                      <SearchSelect
                          v-model="selectedStore"
                          url="v1/get-store"
                          :filterParams="{ status: 1 }"
                          :customLabelFn="customStoreNameForMultiselect"
                          placeholder="Search Store..."
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 user_plan mb-1">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <div class="input-group">
                      <label>Select Terminal</label>
                      <multiselect
                          v-model="selectedTerminal"
                          :options="terminalData"
                          label="label"
                          track-by="id"
                          placeholder="Select Terminal"
                          :loading="terminalLoader"
                          variant="primary"
                          :custom-label="customStoreNameForMultiselect"
                      ></multiselect>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 user_plan">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <div class="input-group">
                      <label>Select Channel</label>
                      <multiselect
                          v-model="selectedChannel"
                          :options="channelData"
                          label="label"
                          track-by="id"
                          placeholder="Select Channel"
                          :loading="channelLoader"
                          variant="primary"
                          :custom-label="customStoreNameForMultiselect"
                      ></multiselect>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 ">
                <input class="form-control mt-sm-50" style="min-height: 42px" @keyup.enter="onSubmitFilters" type="text" v-model="search" placeholder="Search here..."/>
              </div>
            </div>
            <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
              <div class="col-lg-4 mb-1 col-sm-12">
                <button type="button" class="btn btn-primary"  @click="onSubmitFilters" >Search</button>
                <button type="button" class="ml-1 btn btn-danger " @click="clear" >Clear</button>
              </div>
            </div>

          </div>
          <div class="card">
            <CommonTable
                :url="url"
                :tableHeaderValues="tableHeaderValues"
                :actions="actions"
                :deleteActions="deleteActions"
                :mutedData="mutedData"
                :storageKey="storageKey"
                :externalTotalRecord="externalTotalRecord"
                :filteredData="filteredData"
                :showPerPage = true
            />
          </div>
        </div>
      </div>
      <CustomerCardsModal :show="showCardsModal" :data="cardsData"
                          @hide="showCardsModal = false"

      />
    </div>
    <CustomerDetails :rowData="rowData" v-if="!listing"
                        @backFromDetailPage="backFromDetailPage"/>
  </div>
</template>

<script>

import CustomerCardsModal from "@/pages/dashboard/customer/CustomerCardsModal";
import CustomerDetails from "@/pages/dashboard/customer/CustomerDetails";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import SearchSelect from "@/components/common/SearchSelect.vue";

export default {
  components: {SearchSelect, CustomerDetails, CustomerCardsModal, DatePicker},
  mounted() {
    localStorage.setItem("url", "v1/get-customers");
    this.checkDataInStore('v1/get-customers')
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
  },
  data() {
    return {
      listing:true,
      rowData:[],
      url: "v1/get-customers",
      storageKey: "Customers",
      isDefault: false,
      cardsData: [],
      showCardsModal: false,
      tableHeaderValues: [
        {
          title: "Name",
          valueKey: "name",
          html: true,
          alter: function (value) {
            var html = "";
            if (value) {
              html = `<span class="text-primary">${value}</span>`;
              return html;
            } else {
              html = "-";
              return html;
            }
          }
        },
        {
          title: "Email",
          valueKey: "email",
          alter: function (value) {
            if (!value) {
              return "-";
            } else {
              return value;
            }
          }
        },
        {
          title: "Phone",
          valueKey: "phone",
          alter: function (value) {
            if (!value) {
              return "-";
            } else {
              return value;
            }
          }
        },
        {
          title: "Address",
          valueKey: "address",
          alter: function (value) {
            if (!value) {
              return "-";
            } else {
              return value;
            }
          }
        },
        {
          title: 'Country',
          valueKey: 'country',
          html: true,
          alter: function (value) {
            if (!value) {
              return "-";
            } else {
              return value;
            }
          }
        },
        {
          title: 'City',
          valueKey: 'city',
          html: true,
          alter: function (value) {
            if (!value) {
              return "-";
            } else {
              return value;
            }
          }
        },
        {
          title: 'Total Transactions',
          valueKey: 'transactions_count',
          html: true,
          alter: function (value) {
            var html = ''
            html = `<span class="text-info">${value}</span>`


            return html


          }
        },
        {
          title: "Created Date / Time",
          valueKey: "created_at",
          alter: (value) => {
            return this.customFormatDateTime(value)
          }
        },
      ],
      actions: [
        {
          title: "Details",
          class: "btn-primary mt-1",
          cta: (row, index) => {
            this.cardsData = row.cards
            this.showCardsModal = true
          }
        },
        {
          title: "Transactions",
          class: "btn-warning mt-1",
          cta: (row, index) => {
            this.listing = false
            this.rowData = row
          }
        },
      ],
      deleteActions: [],
      mutedData: [],
      externalTotalRecord: "",
      filteredData: {},
      search: '',
      fromDate: null,
      toDate: null,
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      selectedStore: null,
      selectedTerminal: null,
      selectedChannel: null,
      storeData: [],
      terminalData: [],
      channelData: [],
      terminalLoader:false,
      channelLoader:false,
    };
  },
  methods: {
    backFromDetailPage(){
      this.listing = true
    },
    onSubmitFilters() {

      let filterData = {}

      if(this.selectedStore){
        filterData.storeId = this.selectedStore.id
      }
      if(this.selectedTerminal){
        filterData.terminalId = this.selectedTerminal.id
      }
      if(this.selectedChannel){
        filterData.channelId = this.selectedChannel.id
      }

      if(this.search != ''){
        filterData.search = this.search
      }
      if(this.toDate){
        filterData.toDate = this.toDate
      }
      if(this.fromDate){
        filterData.fromDate = this.fromDate
      }

      this.filteredData = filterData






    },
    clear(){
      this.toDate = null
      this.fromDate = null
      this.search = ''
      this.selectedStore = null
      this.selectedTerminal = null
      this.selectedChannel = null
      this.filteredData = {}




    },
    getStoreData() {
      this.makeRequest("post", "v1/get-store", {status:1}, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                if(responseData){
                  this.storeData = responseData;
                }
                else{
                  this.storeData = []
                }
                // this.setSelectedStoreValue();
              }
            }
          }
      );
    },
    setSelectedStoreValue() {


      if (this.selectedStore == null && this.storeData.length > 0) {
        this.selectedStore = this.storeData[0];

      }
      else{
        this.selectedStore = null
      }
    },
    getTerminalData() {
      this.terminalLoader = true
      this.makeRequest("post", "v1/get-terminal", {storeId:this.selectedStore?this.selectedStore.id:'',status:1}, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                if(responseData){
                  this.terminalData = responseData;
                }
                else{
                  this.terminalData = []
                }
                // this.setSelectedTerminalValue();
              }
            }
            this.terminalLoader = false
          }
      );
    },
    setSelectedTerminalValue() {


      if (this.selectedTerminal == null && this.terminalData.length > 0) {
        this.selectedTerminal = this.terminalData[0];

      }
      else{
        this.selectedTerminal = null
      }
    },
    getChannelData() {
      this.channelLoader = true
      this.makeRequest("post", "v1/get-channel", {storeId:this.selectedStore?this.selectedStore.id:'',terminalId:this.selectedTerminal?this.selectedTerminal.id:'',status:1}, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                if(responseData){
                  this.channelData = responseData;
                }
                else{
                  this.channelData = []
                }
                // this.setSelectedChannelValue();
              }
            }
            this.channelLoader = false
          }
      );
    },
    setSelectedChannelValue() {
      if (this.selectedChannel == null && this.channelData.length > 0) {
        this.selectedChannel = this.channelData[0];

      }
      else{
        this.selectedChannel = null
      }
    },
    customStoreNameForMultiselect ({ name,code }) {
      return `${name}/${code}`
    },
  },
  watch:{
    selectedStore(val) {
      this.selectedTerminal = null
      if(!val){
        this.terminalData = []
        return
      }
      this.getTerminalData()
    },
    selectedTerminal(val) {
      this.selectedChannel = null
      if(!val){
        this.channelData = []
        return
      }
      this.getChannelData()
    },
  }
};
</script>
